import React, { useState } from 'react';
import { useTheme } from '@emotion/react';
import {
  type RestModalConfirmCancelModal,
  type RestModalForwards,
} from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import { useMediaQueries } from '@bbkFunnelComponents/modals/sections/media-queries';
import { FunnelButton, FunnelInput } from '../v2';
import HelpText from './sections/help-text';
import ModalSimpleActions from './sections/simple-actions';
import ModalTitle from './sections/title';
import CustomerHtml from '../customer_html/customer_html';

type Props = {
  info: RestModalConfirmCancelModal;
  onClick: (action: RestModalForwards) => void;
};
export const ConfirmCancellationModal: React.FC<Props> = ({
  info,
  onClick,
}) => {
  const [deleteTyped, setDeleteTyped] = useState(false);
  const [deleteValue, setDeleteValue] = useState('');
  const theme = useTheme() as EmotionTheme;
  const equalButtonSize = theme.complianceEqualButtonSize;

  const phrase = info.requires.info.phrase || 'DELETE';
  const mobileView = useMediaQueries();

  const handleInput = (value: string) => {
    const trimmedValue = value.trim();
    const deletePhrase = new RegExp(`^${phrase}$`, 'gi');
    const testPhrase = trimmedValue.match(deletePhrase) !== null;
    setDeleteTyped(testPhrase);
    setDeleteValue(trimmedValue);
  };
  const { cta, placeholder } = info.requires.info;

  return (
    <div className="confirm-cancelation-modal">
      <ModalTitle info={info.requires.info} />
      <div className="CCContainer">
        <HelpText
          cta={cta ?? 'Please type %s in the box below to close your account'}
          phrase={phrase}
        />
        <div className="textfield">
          <FunnelInput
            placeholder={placeholder || 'Start typing...'}
            name="delete"
            value={deleteValue}
            onChange={(e) => handleInput(e.target.value)}
          />
        </div>
        {/* For mobile LA have extra 15px padding when buttons have 100% width, to make it same added extra 15px here */}
        <div
          className={cs('bbk-button-proceed', {
            'tw-px-[15px]': equalButtonSize && mobileView,
            'tw-flex tw-justify-center': equalButtonSize && !mobileView,
          })}
        >
          {deleteTyped ? (
            <ModalSimpleActions onClick={onClick} fullModalInfo={info} />
          ) : (
            <FunnelButton disabled specificStyles={{ width: '100%' }}>
              <CustomerHtml value={info.requires.forwards.text} />
            </FunnelButton>
          )}
        </div>
        {info && (
          <div className="terms">
            <CustomerHtml value={info.requires.info.terms} />
          </div>
        )}
      </div>
    </div>
  );
};

ConfirmCancellationModal.closeBtnFill = '#9d9d9d';
